export const useBlogPostNamedRoute = ({
    slug,
    type,
}: {
    slug: string
    type: BlogPostType
}): VNuxtLinkTo => {
    if (type === 'magazine') {
        return {
            name: 'magazine-detail',
            params: { id: slug },
        }
    }
    if (type === 'blog') {
        return {
            name: 'magazine-detail',
            params: { id: slug },
        }
    }

    return slug
}
